import styled from 'styled-components';
// import { PRIMARY_COLOR } from './../constants/color';
export const QuestionWrapper: any = styled.div`

.pageContent{
    padding-top: 150px;
}

//Pages Header
.pagesSection{
    display: flex;
}
.pagesSection label{
    margin: 7px 7px 0px 7px;
}
.pagesSection .pageMenuItem{
    display: inline-flex;
    margin: 0px;
}
.pageHeading .pagesSection label{
    display: inline-block;
}
.pageHeading .pagesSection select{
    display: inline-block;
}
//Pages Header

.borderRadius>div>div:first-child {
    padding: 10px 25px;
}

.cluster{
    border-left: 4px solid #bdbdbd;
    border-right: none;
    border-top: 1px solid #e6e6e6;
    // border-bottom: 1px solid #ccc;
    margin-bottom:30px;
    // padding: 15px 30px;
    padding: 15px 30px 0px;
}

.cluster:after{
    content: '';
    border-top: 1px solid #e6e6e6;
    height: 1px;
    width: 50%;
    display: block;
    position: relative;
    top: 1px;
    z-index: -1;
    left: -31px;
}

.addQuestion{
    position: relative;
    left: -6%;
    bottom: -100px;
}
.addCluster .btn-blue{
    float: right;
    border-color: #0099ff
}
.addCluster:after{
    content: '';
    border-top: 1px solid #0099ff;
    height: 1px;
    width: 70%;
    display: block;
    position: relative;
    top: 20px;
    z-index: -1;
    left: 0px;
}
.footerSection .alignLeft{
    width: 17%;
}
 .optionsWrapper{
//     border: 1px solid #bdbdbd;
//     padding: 15px;
//     margin-left: 9%;
//     margin-bottom: 2%;
//     width: 100%;
    padding: 15px 0px 15px 0px;
    //border-left: 4px solid #bdbdbd;
}
.optionsBox{
    padding: 20px 0px 20px 40px;
    border-left: 4px solid #bdbdbd;
}
.addOptions{
    padding: 15px 0px 15px 40px;
    border-left: 4px solid #bdbdbd;
    margin-bottom: 15px;
}
.no-pad{
    padding: 0 !important;
}

.pull-right{
    float: right
}
.btn-close{
    color: red;
    cursor: pointer;
    text-decoration: none;
}
.padding-top-50{
    padding-top: 50px;
}
.error{
    // color: #c9302c;
    color: #cc0000;
    margin: 10px 0px;
  }
  .opt-error{
    margin: 85px 55px;
    display: block;
    float: right;
  }

  .cluster .popperDropdownMenu{
      position: absolute;
      right: 5%;
  }

  .handleMove .moveUpDown{
    position: relative;
    width: 48px;
    height: 48px;
  }
  .handleMove .moveUpDown .moveUp{
    position: absolute;
    top: 7px;
    left: 12px;
  }
  .handleMove .moveUpDown .moveDown{
    top: 20px;
    position: absolute;
    left: 12px;
  }
  .isMandatory span + span{
      font-weight: bold;
  }
  .displayStatus{
    display:inline-flex;
    margin-top: 14px;
  }
.displayStatus span{
    width: 180px;
    padding-left: 10px;
    font-size: 14px!important;
    font-weight: bold;
}
.displayStatus button{
    width: 140px;
    pointer-events:visible!important;
}
 .disableQuetionDiv{
        pointer-events: none !important;
        opacity: 1;
    }
.buttonDisabled{
    background-color:#CCC!important;
}
`


// WEBPACK FOOTER //
// ./src/styles/question.tsx